import { HighlightedText } from 'src/shared/utils/text-highlighter/TextHighlighter'
import styles from 'src/styles/common.module.scss'

export const TextContentEl = () => {
    return (
        <HighlightedText
            text="ΚΕΡΔΙΣΑΤΕ 400 ΔΩΡΕΑΝ ΠΕΡΙΣΦΤΡΟΦΕΣ"
            highlights={[{ word: '400' }]}
            breakAfterWords={['ΚΕΡΔΙΣΑΤΕ', 'ΔΩΡΕΑΝ']}
            className={styles.text_content}
        />
    )
}
